interface QuickAddBindingOptions {
  onQuickAdd: (variantId: string, button: HTMLButtonElement) => void;
}

export function bindQuickAddCtaButtons(
  container: ParentNode,
  options: QuickAddBindingOptions
): void {
  const buttons = container.querySelectorAll<HTMLButtonElement>(".add_to_cart_button");

  for (const button of buttons) {
    if (button.dataset.quickAddBound === "1" || button.disabled) {
      continue;
    }

    button.dataset.quickAddBound = "1";
    if (!button.dataset.defaultLabel) {
      button.dataset.defaultLabel = button.textContent?.trim() ?? "Quick Add";
    }

    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const variantId = button.dataset.id;
      if (!variantId) {
        return;
      }

      options.onQuickAdd(variantId, button);
    });
  }
}
